import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, Link } from 'react-router-dom';

import { logout } from '../../actions/auth';

const Navbar = () => {

    const dispatch = useDispatch();

    const { permisos } = useSelector(state => state.auth.usuario);

    const handleLogout = () => {
        dispatch(logout());
    }

    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
            <div className="container-fluid">
                <div className="w-100">
                    <Link className='navbar-brand' to='/dashboard'>
                        <img src={process.env.REACT_APP_PUBLIC_ROUTE + '/assets/images/logo-blanco.png'} alt="logo" height="35" style={{ marginRight: '0.5rem', verticalAlign: 'baseline' }} />
                    </Link>
                    <button className="navbar-toggler float-end" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                </div>
                <div className="collapse navbar-collapse d-lg-flex justify-content-lg-center px-3" id="navbarNavDropdown">
                    <ul className="navbar-nav text-right">
                        <li className="nav-item">
                            <NavLink className={'nav-link'} to='/dashboard'>Inicio</NavLink>
                        </li>
                        {
                            permisos?.locatarios?.ver ?
                            <li className="nav-item"><NavLink className={'nav-link'} to='/locatarios'>Locatarios</NavLink></li>
                            :
                            null
                        }
                        {
                            permisos?.clientes?.ver ?
                                <li className="nav-item"><NavLink className={'nav-link'} to='/clientes'>Clientes</NavLink></li>
                            :
                                null
                        }
                        {
                            permisos?.usuarios?.ver ?
                                <li className="nav-item"><NavLink className={'nav-link'} to='/usuarios'>Usuarios</NavLink></li>
                            :
                                null
                        }
                        {
                            permisos?.citas?.ver ?
                                <li className="nav-item"><NavLink className={'nav-link'} to='/citas/calendario'>Citas</NavLink></li>
                            :
                                null
                        }
                        {
                            permisos?.reportes?.ver ?
                                <li className="nav-item"><NavLink className={'nav-link'} to='/reportes'>Reportes</NavLink></li>
                            :
                                null
                        }
                        <li className="nav-item dropdown mr-3">
                            <a className={'nav-link dropdown-toggle'} href="#" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                Configuración
                            </a>
                            <ul className="dropdown-menu dropdown-menu-dark dropdown-menu-end" aria-labelledby="navbarDropdownMenuLink">
                                {
                                    permisos?.configuracion?.servicios?.ver ?
                                        <li><NavLink className={'dropdown-item'} to='/configuracion/servicios'>Servicios</NavLink></li>
                                    :
                                        null
                                }
                                {
                                    permisos?.configuracion?.membresias?.ver ?
                                        <li><NavLink className={'dropdown-item'} to='/configuracion/membresias'>Membresias</NavLink></li>
                                    :
                                        null
                                }
                                {
                                    permisos?.configuracion?.paquetes?.ver ?
                                        <li><NavLink className={'dropdown-item'} to='/configuracion/paquetes'>Paquetes</NavLink></li>
                                    :
                                        null
                                }
                                {
                                    permisos?.configuracion?.perfil?.ver ?
                                        <li><NavLink className={'dropdown-item'} to='/configuracion/perfil'>Perfil</NavLink></li>
                                    :
                                        null
                                }
                                <li><a className="dropdown-item" onClick={handleLogout} href="/">Cerrar sesión</a></li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    )
}

export default Navbar;